import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RevShareModal from "../../common/overrides/RevShareModal";
import { removeFaq } from "../../../redux/actions/FaQActions";
import { REMOVE_FAQ_SUCCESS } from "../../../redux/actions/ActionTypes";

class RemoveFaqVarificationModal extends React.Component {
  render(props) {
    return (
      <RevShareModal
        api={REMOVE_FAQ_SUCCESS}
        buttonText="Remove"
        buttonVariant="danger"
        modalSize="sm"
        selfClosing
        title="Remove Question"
        yesButtonClickedText="Removing"
        yesButtonOnClick={this.remove}
        yesButtonText="Remove"
        yesButtonVariant="danger"
      >
        <p>Are you sure you want to remove this question?</p>
        <p>Deleted questions cannot be recovered</p>
      </RevShareModal>
    );
  }

  constructor(props) {
    super(props);

    this.remove = this.remove.bind(this);
  }

  remove() {
    return this.props.removeFaq(this.props.questionId);
  }
}

RemoveFaqVarificationModal.propTypes = {
  questionId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = {
  removeFaq,
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveFaqVarificationModal);
